$(function () {
	$(".staff-item").each(function () {
		const $this = $(this);
		const $button = $this.find(".staff-item-button");
		const $overlay = $this.find(".staff-item-caption-overlay");

		$button.on("mouseenter", function () {
			$button.addClass("active");
			$overlay.addClass("show");
		});
		$this.on("mouseleave", function () {
			$button.removeClass("active");
			$overlay.removeClass("show");
		});
	});
});
